import { trackEvent } from "./analyticsManager";

// Analytics for board multi-select. Three events, all fired at commit points
// (never per frame / per click spree):
//   Board - Multi-Select Created : once, when a selection goes from <2 to 2+
//   Board - Group Action         : an action applied to 2+ selected objects
//   Board - Multi-Select Mode    : the mode toggled on/off (with duration on off)

export type MultiSelectMethod =
  | "shift_click"
  | "cmd_click"
  | "mode_click"
  | "marquee"
  | "select_all"
  | "modifier_drag";

export type GroupAction =
  | "move"
  | "nudge"
  | "rotate"
  | "scale"
  | "elevate"
  | "delete"
  | "duplicate"
  | "paste"
  | "lock"
  | "unlock"
  | "material_apply";

export type ModeSource = "button" | "key" | "escape" | "api";

// Which entry point a toggle click used.
export const clickMethod = (e: any, modeOn: boolean): MultiSelectMethod =>
  e?.shiftKey ? "shift_click" : e?.metaKey || e?.ctrlKey ? "cmd_click" : modeOn ? "mode_click" : "shift_click";

export function trackMultiSelectCreated(
  method: MultiSelectMethod,
  beforeCount: number,
  afterCount: number,
  ctx: { modeOn: boolean; objectCount: number },
) {
  if (beforeCount >= 2 || afterCount < 2) return;
  trackEvent("Board - Multi-Select Created", {
    method,
    mode_on: ctx.modeOn,
    object_count: ctx.objectCount,
  });
}

export function trackGroupAction(action: GroupAction, count: number, extra: Record<string, unknown> = {}) {
  if (count < 2) return;
  trackEvent("Board - Group Action", { action, count, ...extra });
}

let modeOnAt: number | null = null;

export function trackMultiSelectMode(on: boolean, source: ModeSource) {
  if (on) {
    modeOnAt = Date.now();
    trackEvent("Board - Multi-Select Mode", { on: true, source });
    return;
  }
  const duration_s = modeOnAt == null ? null : Math.round((Date.now() - modeOnAt) / 1000);
  modeOnAt = null;
  trackEvent("Board - Multi-Select Mode", { on: false, source, duration_s });
}
